import { environmentConfiguration } from '@/config/environments'
import { Path, Values } from 'vue-i18n'
import { i18n } from '@/config/i18n'

export function translate(key: Path, values?: Values) {
  const project: string | null = environmentConfiguration().branding
  let prefix: string = ''

  if (project) {
    prefix = project + '.'
  }

  const prefixedKey = prefix + key
  let translation = i18n.t(prefix + key, values)

  if (translation === prefixedKey) {
    translation = i18n.t(key, values)
  }

  return translation
}
